<template>

  <nav class="level is-mobile crosstab-menu" v-show="shouldDisplay">

    <div class="level-item menu-item">
      <p class="heading">Graph</p>
      <app-toggle-switch :model-value="showGraphs" size="lg" @toggle="setShowGraphOption(!showGraphs)"></app-toggle-switch>
    </div>

    <div class="level-item menu-item">
      <p class="heading"><span v-if="expandIsCompress">Collapse</span><span v-else>Expand</span></p>
      <app-icon-button :disabled="!expandEnabled" :icon="expandIsCompress ? 'collapse' : 'expand'" size="lg" @click="expand"></app-icon-button>
    </div>

    <div class="level-item menu-item" :class="{disabled: !hasTwoVars}">
      <p class="heading">Flip</p>
      <app-icon-button :disabled="!hasTwoVars" @click="swapVariables" size="lg" icon="flip"></app-icon-button>
    </div>

    <div class="level-item menu-item">
      <p class="heading">Measure</p>
        <app-modal-dropdown :button-class="buttonClasses.concat(['is-small-mobile'])" :button-style="measureStyle" :options="availableMeasures" :value="measure" valueAttribute="value" :labelAttribute="measureLabelAttr" @optionSelected="setMeasure">
      </app-modal-dropdown>
    </div>

    <div class="level-item menu-item">
      <p class="heading">Share</p>
      <app-icon-button @click="openShareModal" icon="share" size="lg"></app-icon-button>

      <app-popup title="Share this data" :open="showShareModal" @dismiss="showShareModal = false">
        <label for="share-link" class="label">Share Link</label>
        <div class="field has-addons">
          <div class="control is-expanded">
            <input id="share-link" type="text" readonly :value="shareLink" class="input" ref="shareTextbox" />
          </div>
          <div class="control">
            <use-clipboard v-slot="{ copy }" :source="shareLink">
              <button type="button" ref="clipboard-button" class="button" title="Copy Link into Clipboard" @click="copy()">
              <span class="icon is-medium">
                <app-icon size="lg" icon="clipboard"></app-icon>
              </span>
              </button>
            </use-clipboard>
          </div>
        </div>
      </app-popup>
    </div>

  </nav>

</template>

<script>

  import AppIconButton from "App/components/AppIconButton";
  import AppToggleSwitch from "App/components/AppToggleSwitch";
  import AppModalDropdown from "App/components/AppModalDropdown";
  import AppPopup from "App/components/AppPopup";
  import AppSvg from "App/components/AppSvg";
  import { UseClipboard } from "@vueuse/components";
  import { mapActions, mapState } from "pinia";
  import { useMediaQueryStore } from "App/stores/mediaQuery";
  import { useSelectionStore } from "App/stores/selection";
  import { useTabulationStore } from "App/stores/tabulation";
  import { recordTabulationMenuAction } from "App/lib/Analytics";

  export default {
    data() {
      return {
        showShareModal: false
      }
    },

    computed: {
      ...mapState(useSelectionStore, {
        showGraphs: store => store.dataDisplayOptions.showGraphs,
        availableMeasures: store => store.dataDisplayOptions.availableMeasures,
        measure: store => store.dataDisplayOptions.measure,
        hasTwoVars: store => store.selectedVariables.length === 2,
        serializedSession: 'serializedSession'
      }),
      ...mapState(useTabulationStore, ["crossTabData"]),
      ...mapState(useMediaQueryStore, { isMobile: 'mobile' }),


      shouldDisplay() {
        return this.crossTabData != null;
      },
      buttonClasses() {
        return ["button", "is-white"];
      },
      shareLink() {
        const serializedSession = this.serializedSession;
        const l = window.location;
        return l.protocol + "//" + l.host + `/session?session=${serializedSession}`;
      },
      measureLabelAttr() {
        if (this.isMobile) {
          return 'shortName';
        } else {
          return 'name';
        }
      },
      measureStyle() {
        if (this.isMobile) {
          return {padding: '2px'};
        } else {
          return {};
        }
      },
      expandEnabled() {
        return this.crossTabData !== null && this.hasTwoVars;
      },
      expandIsCompress() {
        if (this.crossTabData !== null) {
          return this.crossTabData.findIndex(c => c.show) >= 0;
        } else {
          return false;
        }
      }
    },

    methods: {
      ...mapActions(useSelectionStore, [
        'setShowGraphOption',
        'setMeasureOption',
        'swapVariables',
      ]),
      ...mapActions(useTabulationStore, [
        'setCrossTabCollapse'
      ]),

      setMeasure(val) {
        this.setMeasureOption(val);
      },
      openShareModal() {
        recordTabulationMenuAction("share");
        this.showShareModal = true;
        setTimeout(() => {
          this.$refs.shareTextbox.focus();
          this.$refs.shareTextbox.select();
        });
      },
      expand() {
        if (this.crossTabData === null) {
          return;
        }

        const collapse = this.expandIsCompress;
        this.setCrossTabCollapse(collapse);
      }
    },

    components: {
      AppToggleSwitch,
      AppModalDropdown,
      AppPopup,
      AppSvg,
      AppIconButton,
      UseClipboard
    }
  }

</script>

<style lang="scss" scoped>
  @import "~App/styles/variables";
  @import "~bulma/sass/utilities/mixins";

  nav.crosstab-menu {
    align-items: flex-start;

    @include mobile {
      .heading {
        font-size: 0.6rem;
      }
    }
  }

  .level-item.menu-item {
    flex-direction: column;
    margin-right: 0.25rem;

    &:last-child {
      margin-right: 0;
    }

    p {
      margin: 2px;
      float: none;
    }
  }

</style>